import { render } from "./LectureImageModal.vue?vue&type=template&id=ad6fec52&scoped=true"
import script from "./LectureImageModal.vue?vue&type=script&lang=js"
export * from "./LectureImageModal.vue?vue&type=script&lang=js"

import "./LectureImageModal.vue?vue&type=style&index=0&id=ad6fec52&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad6fec52"]])

export default __exports__